import { baseTextos } from '@baseValues'
import { Getter, Setter, Store } from '@types'
import { DEFAULT_CULTURE, logI18nDiagnostics } from '@utils/i18nLocale'

export function t(
  set: Setter,
  get: Getter,
  str: number | keyof Store['textos']['textos'] | string,
): string {
  const textos = get().textos

  if (!textos.textos) return str as string
  if (!(str in textos.textos)) return str as string
  if (!str) return ''
  //TODO: check once again this shit property access
  return textos.textos[str]
}

export async function setTextos(get: Getter, set: Setter, textos: Store['textos']) {
  const merged = {
    idioma: textos.idioma ?? get().textos.idioma ?? baseTextos.idioma,
    textos: { ...baseTextos.textos, ...(textos.textos ?? {}) },
  }

  set((store) => {
    store.textos = merged
  })

  logI18nDiagnostics(
    merged.textos,
    merged.idioma?.nombreCultura ?? DEFAULT_CULTURE,
  )
}
